import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=c6c77fc4&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=c6c77fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c77fc4",
  null
  
)

export default component.exports